(function () {
  var REVIEW_PREVIEW_LIMIT = 3;

  // Loop-safety guards. The observer callback used to mutate the very
  // attributes/children it was observing (class/style + inserting the
  // show-more button), which re-triggered the observer in a tight feedback
  // loop and hung the main thread ("Page Unresponsive"), freezing gallery
  // hydration. These flags make the reveal + preview-limit run at most once
  // and let us disconnect before mutating so we can never re-enter.
  var unhidden = false;
  var previewDone = false;
  var activeObserver = null;

  function getReviewWidget() {
    return document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
  }

  function getReviewsMount() {
    return document.querySelector('[data-vibee-pdp-reviews-mount]');
  }

  function readReviewCount(widget) {
    if (!widget) return 0;
    var widg = widget.querySelector('.jdgm-rev-widg');
    if (!widg) return 0;
    var count = Number(widg.getAttribute('data-number-of-reviews') || 0);
    return Number.isNaN(count) ? 0 : count;
  }

  function localizeJudgeMeWidget(widget) {
    if (!widget) return;
    var locale = (window.Shopify && Shopify.locale) || document.documentElement.lang || 'tr';
    var isTr = locale.indexOf('tr') === 0;

    var title = widget.querySelector('.jdgm-rev-widg__title');
    if (title && isTr) {
      if (/customer reviews/i.test(title.textContent)) {
        title.textContent = 'Müşteri Yorumları';
      }
    }

    var summaryText = widget.querySelector('.jdgm-rev-widg__summary-text');
    if (summaryText && isTr) {
      summaryText.textContent = summaryText.textContent
        .replace(/Based on\s+([\d.,]+)\s+reviews?/i, '$1 değerlendirme')
        .replace(/(\d[\d.,]*)\s+reviews?/i, '$1 değerlendirme');
    }

    var writeLink = widget.querySelector('.jdgm-write-rev-link, .jdgm-btn[data-link="write"]');
    if (writeLink && isTr && /write a review/i.test(writeLink.textContent)) {
      writeLink.textContent = 'Yorum yaz';
    }

    if (!isTr) return;

    // Sort / filter dropdown options. We only relabel the visible <option> text;
    // the option `value` is untouched so Judge.me sorting/filtering keeps working.
    // Idempotent: once translated the English key no longer matches.
    var sortMap = {
      'most recent': 'En Yeni',
      'most helpful': 'En Faydalı',
      'highest rating': 'En Yüksek Puan',
      'lowest rating': 'En Düşük Puan',
      'pictures first': 'Önce Fotoğraflılar',
      'videos first': 'Önce Videolular',
      'with photos': 'Fotoğraflı',
      'with photos and videos': 'Fotoğraflı ve Videolu',
      'only photos': 'Sadece Fotoğraflı'
    };
    var options = widget.querySelectorAll('option');
    for (var i = 0; i < options.length; i++) {
      var optKey = (options[i].textContent || '').trim().toLowerCase();
      if (sortMap.hasOwnProperty(optKey)) {
        options[i].textContent = sortMap[optKey];
      }
    }

    // "Verified Buyer" badges. Only touch text-only nodes (no element children)
    // so we never strip an accompanying check icon. Idempotent via regex guard.
    var buyerBadges = widget.querySelectorAll('.jdgm-rev__buyer-badge, [class*="buyer-badge"]');
    for (var b = 0; b < buyerBadges.length; b++) {
      var badge = buyerBadges[b];
      if (badge.childElementCount === 0 && /verified buyer/i.test(badge.textContent)) {
        badge.textContent = badge.textContent.replace(/verified buyer/i, 'Doğrulanmış Alıcı');
      }
    }
  }

  function limitReviewPreview(widget) {
    if (previewDone) return;
    if (!widget) return;
    var mount = getReviewsMount();
    var showMoreLabel = mount ? mount.getAttribute('data-reviews-show-more') : '';
    var reviews = widget.querySelectorAll('.jdgm-rev');
    // Reviews may still be streaming in; don't lock the preview in until we
    // actually have more than the limit to collapse.
    if (reviews.length <= REVIEW_PREVIEW_LIMIT) return;

    reviews.forEach(function (rev, index) {
      if (index >= REVIEW_PREVIEW_LIMIT) {
        rev.classList.add('vibee-pdp__review--hidden');
      }
    });

    if (!mount || mount.querySelector('[data-vibee-reviews-show-more]')) {
      previewDone = true;
      return;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vibee-pdp__reviews-show-more is-visible';
    btn.setAttribute('data-vibee-reviews-show-more', '');
    btn.textContent = showMoreLabel || 'Show more reviews';
    btn.addEventListener('click', function () {
      reviews.forEach(function (rev) {
        rev.classList.remove('vibee-pdp__review--hidden');
      });
      btn.classList.remove('is-visible');
      btn.hidden = true;
    });

    var list = widget.querySelector('.jdgm-rev-widg__reviews') || widget.querySelector('.jdgm-rev-widg');
    if (list) {
      list.insertAdjacentElement('afterend', btn);
    } else {
      mount.appendChild(btn);
    }

    previewDone = true;
  }

  function unhideJudgeMeWidget() {
    // Run the reveal at most once. After we have successfully shown a widget
    // that contains reviews, there is nothing left to do, so bail immediately.
    if (unhidden) return;

    var widget = getReviewWidget();
    if (!widget) return;

    var count = readReviewCount(widget);
    if (count <= 0 && !widget.querySelector('.jdgm-rev')) return;

    // We have a real widget with reviews: disconnect BEFORE mutating so the
    // style/class/childList changes below can never re-enter this callback,
    // and mark the work done so any queued pass/event no-ops.
    if (activeObserver) {
      activeObserver.disconnect();
      activeObserver = null;
    }
    unhidden = true;

    document.querySelectorAll('style.jdgm-temp-hiding-style').forEach(function (el) {
      el.remove();
    });

    var widg = widget.querySelector('.jdgm-rev-widg');
    if (widg) {
      widg.style.removeProperty('display');
      widg.style.removeProperty('visibility');
    }

    widget.querySelectorAll('.jdgm-temp-hidden').forEach(function (el) {
      el.classList.remove('jdgm-temp-hidden');
    });

    // Review cosmetics operate on third-party Judge.me markup; never let an
    // unexpected DOM shape throw and bubble out of the observer/timeout passes.
    try {
      localizeJudgeMeWidget(widget);
      limitReviewPreview(widget);
    } catch (e) {
      /* no-op: keep the widget visible even if localize/limit fails */
    }
  }

  function observeWidget(widget) {
    if (unhidden) return;

    var observer = new MutationObserver(function () {
      unhideJudgeMeWidget();
    });

    activeObserver = observer;

    // Watch only the signals that indicate Judge.me has mounted/loaded its
    // reviews (new nodes + the review-count attribute). We deliberately do
    // NOT observe 'class' or 'style', because unhideJudgeMeWidget() mutates
    // those itself — observing them is what created the infinite feedback
    // loop. Combined with the disconnect-before-mutate in the callback, the
    // observer can fire only a bounded number of times.
    observer.observe(widget, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-number-of-reviews'],
    });
  }

  function scheduleUnhidePasses() {
    [0, 100, 500, 1500, 3000, 6000].forEach(function (delay) {
      window.setTimeout(unhideJudgeMeWidget, delay);
    });
  }

  function init() {
    var anchor = document.getElementById('yorumlar');
    if (!anchor) return;

    try {
      runInit(anchor);
    } catch (e) {
      /* defensive: this script must never throw and disturb the page */
    }
  }

  function runInit(anchor) {
    scheduleUnhidePasses();

    var widget = getReviewWidget();
    if (widget) {
      observeWidget(widget);
      unhideJudgeMeWidget();
    } else {
      var mountObserver = new MutationObserver(function () {
        var currentWidget = getReviewWidget();
        if (!currentWidget) return;
        mountObserver.disconnect();
        observeWidget(currentWidget);
        unhideJudgeMeWidget();
        scheduleUnhidePasses();
      });
      mountObserver.observe(anchor, { childList: true, subtree: true });
    }

    document.addEventListener('jdgm.doneSetup', unhideJudgeMeWidget);
    document.addEventListener('jdgm.widgetRefreshed', unhideJudgeMeWidget);

    // After Judge.me re-renders the list (sort/filter/pagination) it re-emits the
    // English option/badge strings. Re-run ONLY the localization pass — never the
    // reveal/observer logic — so there is no MutationObserver and no feedback loop.
    // localizeJudgeMeWidget is idempotent, so repeat calls are safe.
    function relocalize() {
      var w = getReviewWidget();
      if (!w) return;
      try {
        localizeJudgeMeWidget(w);
      } catch (e) {
        /* no-op: cosmetics on third-party markup must never throw */
      }
    }
    document.addEventListener('jdgm.widgetRefreshed', relocalize);
    document.addEventListener('jdgm.doneSetup', relocalize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
